import NotificationSetting from './NotificationSetting'
import AlarmRealTime from './AlarmRealTime'
import DetailHeader from './DetailHeader'
import { Grid } from '@mui/material'
import ParamsTable from './ParamsTable'
import { useAuth } from '../../../../../hook/useAuth'
import { useCallback, useContext, useEffect, useState } from 'react'
import { urlConfig } from '../../../../../config/apiConfig'
import axiosInstance from '../../../../../config/axiosConfig'
import { AlertContext } from '../../../../../context/AlertContext'

export default function DetailContainer({
    deviceId,
    data,
    user,
    create,
    update,
    remove,
    handleAlert,
    typeAlarm,
    connectedWB,
    typeDevice,
}) {
    const { auth } = useAuth()
    const [device, setDevice] = useState([])
    const { handleOpen } = useContext(AlertContext)
    const [dataTpye, setDataType] = useState(false)
    const [color, setColor] = useState('gray')

    const handleDeviceDetail = useCallback(async () => {
        try {
            const resp = await axiosInstance.get(
                `${urlConfig.deviceIot}/id/${data.device_id}`,
            )
            if (resp.data.status === 200) {
                setDevice(resp.data.message)
            }
            handleOpen({ open: false })
        } catch (error) {
            setDevice([])
            handleOpen({
                open: true,
                message:
                    error.response?.data.message ||
                    'Failed to fetch device details',
                isSuccess: false,
            })
        }
    }, [data.device_id])

    const handleWebSocketData = useCallback(() => {
        if (typeDevice.device_id !== data.device_id) return
        setDevice(typeDevice.data)
        setDataType(true)
    }, [typeDevice, typeDevice, data])

    useEffect(() => {
        if (
            connectedWB &&
            data &&
            typeDevice &&
            typeDevice.device_id === data.device_id
        ) {
            handleWebSocketData()
        }
    }, [handleWebSocketData])

    useEffect(() => {
        let timeoutId
        let cancelled = false

        const fetchLoop = async () => {
            //  if (!connectedWB || !dataTpye) {
            //      await handleDeviceDetail()
            //      if (!cancelled) {
            //          timeoutId = setTimeout(fetchLoop, 3000)
            //      }
            //  }

            await handleDeviceDetail()
            if (!cancelled) {
                timeoutId = setTimeout(fetchLoop, 3000)
            }
        }

        fetchLoop()

        return () => {
            cancelled = true
            clearTimeout(timeoutId)
        }
    }, [])

    useEffect(() => {
        handleDeviceDetail()
    }, [typeAlarm])

    useEffect(() => {
        let interval
        let timeout
        if (device?.status === 'Online') {
            if (device?.type_alert === 'Trigger state') {
                if (device.alarm_type) {
                    const alarmTimeInterval = device?.alarm_time_interval * 1000

                    interval = setInterval(() => {
                        setColor((prevColor) =>
                            prevColor === '#F5C944' ? '#554512' : '#F5C944',
                        )
                    }, 500)

                    timeout = setTimeout(() => {
                        clearInterval(interval)
                        setColor('#4CAF50')
                    }, alarmTimeInterval)
                } else {
                    setColor('#4CAF50')
                }
            } else if (device?.type_alert === 'Remain state') {
                if (device.alarm_type) {
                    interval = setInterval(() => {
                        setColor((prevColor) =>
                            prevColor === '#EA3230' ? '#5E0E11' : '#EA3230',
                        )
                    }, 500)
                } else {
                    setColor('#4CAF50')
                }
            }
        } else {
            setColor('gray')
        }

        return () => {
            clearInterval(interval)
            clearTimeout(timeout)
        }
    }, [device])

    return (
        <Grid
            container
            display={'flex'}
            justifyContent={'space-between'}
            flexDirection={'row-reverse'}
        >
            <Grid item xs={12} sm={7.5} lg={8.8} order={2}>
                <Grid item>
                    <DetailHeader
                        data={data}
                        typeDevice={typeDevice}
                        handleAlert={handleAlert}
                        user={user}
                        connectedWB={connectedWB}
                        deviceDetail={device}
                        color={color}
                    />
                </Grid>
                <Grid item my={3}>
                    <AlarmRealTime
                        deviceId={data?.device_id}
                        deviceData={data}
                        typeAlarm={typeAlarm}
                        connectedWB={connectedWB}
                    />
                </Grid>
                <Grid item>
                    {auth.group === 'Admin' && (
                        <NotificationSetting
                            deviceDetail={device}
                            deviceId={deviceId}
                            dataItem={data}
                            user={user}
                            create={create}
                            update={update}
                            remove={remove}
                        />
                    )}
                </Grid>
            </Grid>
            <Grid item xs={12} sm={4} lg={3} order={1} mb={{ xs: 4, sm: 0 }}>
                <ParamsTable
                    handleOpen={handleOpen}
                    device={device}
                    params={data.deviceTypeParameter}
                    data={data}
                    typeDevice={typeDevice}
                    connectedWB={connectedWB}
                    handleAlert={handleAlert}
                />
            </Grid>
        </Grid>
    )
}
